<template>
  <div :key="key" class="file">
    <div
      v-for="(item, index) in fileList"
      :key="index"
      @click.stop="handlePreview(item, index)"
      class="item"
      :style="{
        backgroundImage: item.type == 'pic' ? 'url(' + item.url + ')' : 'none',
      }"
    >
      <video
        v-if="item.type == 'video'"
        style="width: 100%;height: 100%;"
        :src="item.url"
      ></video>
      <img
        v-if="item.type == 'record'"
        class="img"
        :src="require('@/assets/director/record.png')"
        alt=""
      />
      <div v-if="item.type == 'video'" class="play_mask">
        <a-icon style="font-size: 30px;" type="play-circle" />
      </div>
    </div>
    <a-modal
      :visible="previewModal"
      @cancel="closePreviewModal"
      centered
      title="预览"
      :footer="false"
      :closeable="false"
      :bodyStyle="{ padding: '20px 20px' }"
    >
      <div class="preview-body" v-if="preview">
        <img
          style="width: 100%;height: auto"
          v-if="preview.type == 'pic'"
          :src="preview.url"
        />
        <video
          v-if="preview.type == 'video'"
          :id="preview.id + key"
          style="width: 100%;object-fit: fill;"
          :src="preview.url"
          controls
        ></video>
        <audio
          :id="preview.id + key"
          style="width: 100%;object-fit: fill;"
          v-if="preview.type == 'record'"
          :src="preview.url"
          controls
        ></audio>

        <a-icon
          @click.stop="handleLeft"
          class="arrow-left"
          :class="leftStatus"
          type="left-circle"
        />
        <a-icon
          @click.stop="handleRight"
          class="arrow-right"
          :class="rightStatus"
          type="right-circle"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>


export default {
  name: "fileList",
  data() {
    return {
      preview: null,
      previewModal: false,
      key: 0,
      leftStatus: "",
      rightStatus: "",
      previewIndex: 0,
      fileList:[]
    };
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.key = String(Math.random() * 1000).fixed(0);
  },
  watch: {
    files: {
      handler(val) {
        if (val.length > 0) {
          this.fileList = val.map((arr) => {
            if (arr.type == "pic") {
              arr.url = arr.url + '?x-image-process=image/resize,w_280/quality,Q_120'
            }

            return arr
          })
        }
        this.key++
      },
      immediate: true,
    }
  },
  methods: {
    handleLeft() {
      this.leftStatus = "click";
      const timer = setTimeout(() => {
        this.leftStatus = "";
      }, 200);
      if (this.previewIndex > 0) {
        this.previewIndex--;
        this.rightStatus = "";
      } else {
        this.$message.info("已经到顶部了");
        this.leftStatus = "none";
        clearTimeout(timer);
      }
      this.handlePreview(this.files[this.previewIndex], this.previewIndex);
    },
    handleRight() {
      this.rightStatus = "click";
      const timer = setTimeout(() => {
        this.rightStatus = "";
      }, 200);
      if (this.previewIndex < this.files.length - 1) {
        this.previewIndex++;
        this.leftStatus = "";
      } else {
        this.$message.info("没有更多照片了");
        this.rightStatus = "none";
        clearTimeout(timer);
      }
      this.handlePreview(this.files[this.previewIndex], this.previewIndex);
    },
    closePreviewModal() {
      if (this.preview.type == "video") {
        let video = document.getElementById(this.preview.id + this.key);
        video.pause();
      }
      if (this.preview.type == "record") {
        let audio = document.getElementById(this.preview.id + this.key);
        audio.pause();
      }
      this.previewModal = false;
    },
    deleteFile(index) {
      this.$emit("deleteFile", index);
    },
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
    previewFile(index) {
      this.$emit("previewFile", index);
    },
    handlePreview(file, index) {
      if (file.type == "pic") {
        file.url = this.clearUrl(file.url)
      }
      this.previewIndex = index;
      this.preview = file;
      this.previewModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.arrow-left {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-580px, -50%);
  cursor: pointer;
  z-index: 10;
  font-size: 50px;
  color: #fff;
  &.click {
    opacity: 0.5;
  }
  &.none {
    opacity: 0.3;
  }
}

.arrow-right {
  position: fixed;
  right: 50%;
  top: 50%;
  transform: translate(580px,-50%);
  cursor: pointer;
  z-index: 10;
  font-size: 50px;
  color: #fff;
  &.click {
    opacity: 0.5;
  }
  &.none {
    opacity: 0.3;
  }
}


.file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  width: 100%;
  flex-wrap: wrap;
  .item {
    margin-bottom: 10px;
    width: 160px;
    height: 160px;
    flex-shrink: 0;
    display: block;
    background: #eee;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.file {
  padding: 0;

  .item {
    position: relative;
    margin-right: 10px;
    video {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      object-fit: fill;
    }

    audio {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      object-fit: contain;
    }
  }
}

.play_mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  video {
    object-fit: contain;
  }
}
</style>
